import zxcvbn from 'zxcvbn';

export const validatePassword = (password, userEmail = '') => {
  const errors = [];
  
  // Length check
  if (password.length < 12) {
    errors.push('Password must be at least 12 characters long');
  }
  
  // Uppercase check
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  
  // Lowercase check
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  
  // Number check
  if (!/\d/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  
  // Special character check
  if (!/[@$!%*?&#]/.test(password)) {
    errors.push('Password must contain at least one special character (@$!%*?&#)');
  }
  
  // Check for email parts
  if (userEmail) {
    const emailParts = userEmail.toLowerCase().split('@')[0].split('.');
    for (const part of emailParts) {
      if (part.length > 3 && password.toLowerCase().includes(part)) {
        errors.push('Password cannot contain parts of your email address');
        break;
      }
    }
  }
  
  // Check for common patterns
  const commonPatterns = [
    { pattern: /^123456/, message: 'Password starts with a common sequence' },
    { pattern: /^password/i, message: 'Password contains "password"' },
    { pattern: /^qwerty/i, message: 'Password contains keyboard patterns' },
    { pattern: /^cafua/i, message: 'Password contains company name' },
    { pattern: /(.)\1{2,}/, message: 'Password contains repeated characters' }
  ];
  
  for (const { pattern, message } of commonPatterns) {
    if (pattern.test(password)) {
      errors.push(message);
    }
  }
  
  // Check strength with zxcvbn
  const userInputs = userEmail ? [userEmail.split('@')[0]] : [];
  const strength = zxcvbn(password, userInputs);
  
  if (strength.score < 3) {
    if (strength.feedback.warning) {
      errors.push(strength.feedback.warning);
    }
  }
  
  return {
    isValid: errors.length === 0,
    errors,
    strength: strength.score
  };
};

export const getPasswordRequirements = () => {
  return [
    'At least 12 characters long',
    'At least one uppercase letter (A-Z)',
    'At least one lowercase letter (a-z)',
    'At least one number (0-9)',
    'At least one special character (@$!%*?&#)',
    'Cannot contain parts of your email address',
    'Cannot be a commonly used password',
    'Cannot be the same as your last 5 passwords'
  ];
};